module.exports = __webpack_public_path__ + "static/media/scintillating-space.922ceece.jpg";